import Masonry from 'masonry-layout';

const $galleryImages = document.querySelector<HTMLElement>('#gallery-images');

export let GalleryMasonry: Masonry | null = null;
if ($galleryImages) {
    if ($galleryImages.childElementCount > 3) {
        GalleryMasonry = new Masonry($galleryImages, {
            itemSelector: '.gallery-image-parent:not(.d-none)',
        });
    }
}